import React, { useEffect, useRef, useState } from 'react';
import "./contactpage.css";
import { FaFacebook, FaFacebookSquare, FaInstagramSquare, FaLinkedin, FaUser, FaUserCircle } from 'react-icons/fa';
import { TbWriting } from 'react-icons/tb';
import { HiOutlineChatBubbleBottomCenterText } from 'react-icons/hi2';
import { IoMdChatbubbles } from 'react-icons/io';
import { MdEmail, MdOutlineRateReview } from 'react-icons/md';
import { FaMapLocationDot, FaSquareXTwitter } from 'react-icons/fa6';
import { IoShareSocial } from 'react-icons/io5';
import bgVideo from "./contactpagevideo.mp4";
import bgVideoM from "./contactpagevideomobile.mp4";
import bgVideo2 from "./contactpagevideoblur.mp4";
import { useLanguage } from '../../context/LanguageContext';

const ContactPage = () => {
  const { t, changeLanguage } = useLanguage();
  const topRef = useRef();
  const bottomRef = useRef();
  const [isTopVisible, setIsTopVisible] = useState(false);
  const [isBottomVisible, setIsBottomVisible] = useState(false);

  useEffect(() => {
    const topObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setIsTopVisible(true);
          topObserver.unobserve(entry.target);
        }
      });
    });

    const bottomObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setIsBottomVisible(true);
          bottomObserver.unobserve(entry.target);
        }
      });
    });

    if (topRef.current) {
      topObserver.observe(topRef.current);
    }

    if (bottomRef.current) {
      bottomObserver.observe(bottomRef.current);
    }

    return () => {
      if (topRef.current) {
        topObserver.unobserve(topRef.current);
      }
      if (bottomRef.current) {
        bottomObserver.unobserve(bottomRef.current);
      }
    };
  }, []);

  return (
    <div className="contact-page-container">
      <div className={`contact-page-top-container ${isTopVisible ? 'fade-in' : ''}`} ref={topRef}>

        <div className="contact-page-video-container">
          <video className="contactpage-video" src={bgVideo} autoPlay muted loop playsInline></video>
        </div>

        <div class="contact-page-video-container contact-video-mobile md:hidden">
          <video class="contactpage-video" src={bgVideoM} autoPlay muted loop playsInline></video>
        </div>

        <h1 className="contact-page-title1 mb-8 ">{t('contact-us')}</h1>

        <div className='contact-page-card-container'>
          <a href='https://maps.app.goo.gl/w47e7tC26mNPxXWN7' target='_blank' className='contact-page-card'>
            <FaMapLocationDot className='contact-page-card-icon' />
            <span className='text-[22px] font-bold mb-2'>{t('office-title')}</span>
            <p className='text-[20px]'>{t('office-location')}</p>
          </a>

          <div className='contact-page-card'>
            <IoShareSocial className='contact-page-card-icon' />
            <span className='text-[22px] font-bold mb-2'>{t('social-media-title')}</span>
            <div className='social-media-icon-container'>
              {/* <a href="https://www.facebook.com/profile.php?id=100085283804721" className='contact-page-social-icon'><FaFacebookSquare /></a> */}
              <a href="https://www.instagram.com/pdi_ai/" className='contact-page-social-icon'><FaInstagramSquare /></a>
              {/* <a href="https://twitter.com/AlohaLiveApptr" className='contact-page-social-icon'><FaSquareXTwitter /></a> */}
              <a href="https://www.linkedin.com/company/verius-teknoloji" className='contact-page-social-icon'><FaLinkedin /></a>
            </div>
          </div>


          <div className='contact-page-card'>
            <MdEmail className='contact-page-card-icon' />
            <span className='text-[22px] font-bold mb-2'>{t('email-send-title')}</span>
            <a className='text-[20px] contact-mail-link' href='mailto:bilgi@verius.com.tr' target='_blank'>bilgi@verius.com.tr</a>
            <a className='text-[20px]' href='mailto:info@alohadijital.com' target='_blank'>info@alohadijital.com</a>
          </div>
        </div>
      </div>

      <div className={`contact-page-bottom-container ${isBottomVisible ? 'fade-in' : ''}`} ref={bottomRef}>
        <form>
          <h1 className="contact-page-title2 mb-8">{t('contact-message-title')}</h1>
          <div className='md:grid grid-cols-2 gap-8'>
            <div>
              <h4 className='contact-page-input-title'>{t('contact-name-label')}</h4>
              <input className='contact-page-input' type="text" />
            </div>
            <div>
              <h4 className='contact-page-input-title'>{t('contact-email-label')}</h4>
              <input className='contact-page-input' type="email" />
            </div>
          </div>
          <div>
            <h4 className='contact-page-input-title'>{t('contact-subject-label')}</h4>
            <input className='contact-page-input' type="text" />
          </div>
          <div>
            <h4 className='contact-page-input-title'>{t('contact-message-label')}</h4>
            <textarea className='contact-page-message-input' placeholder={t('contact-message-placeholder')} />
          </div>
          <input type="submit" className='contact-page-submit-button' value={t('contact-submit-button')} />
        </form>
      </div>
    </div>
  );
};

export default ContactPage;